import { Translator } from 'components/i18n';

import 'assets/logo_dark.svg';
import LogoDark from 'assets/logo_dark.svg?react';
import 'assets/logo_light.svg';
import LogoLight from 'assets/logo_light.svg?react';
import { cn } from '@/lib/utils';

import { useTheme } from './ThemeProvider';
import { useSidebar } from '@/components/ui/sidebar'; // Import the sidebar hook

export default function WaterMark() {
  const { variant } = useTheme();
  const { open, openMobile, isMobile } = useSidebar(); // Get sidebar state
  const sidebarOpen = isMobile ? openMobile : open; // Determine if sidebar is open
  const Logo = variant === 'light' ? LogoLight : LogoDark;

  return (
// <a
    //   href="https://github.com/Chainlit/chainlit"
    //   target="_blank"
    //   className="watermark"
    //   style={{
    //     display: 'flex',
    //     alignItems: 'center',
    //     textDecoration: 'none'
    //   }}
    // >
    //   <div className="text-xs text-muted-foreground">
    //     <Translator path="chat.watermark" />
    //   </div>
    //   <Logo
    //     style={{
    //       width: 65,
    //       height: 'auto',
    //       filter: 'grayscale(1)',
    //       marginLeft: '4px'
    //     }}
    //   />
    // </a>
    <div className={cn(
      'text-xs py-1 px-4 fixed bottom-0 w-full z-10',
      'border-t',
      'flex items-center justify-between',
      variant === 'light' 
      ? 'bg-[#003F2D]/80 text-white border-[#003F2D]/20' 
      : 'bg-[#003F2D]/90 text-slate-200 border-[#003F2D]/30',
      'backdrop-blur-sm',
      sidebarOpen ? 'pr-64' : '' // Add right padding when sidebar is open to shift content left
    )}>
      <div className="flex items-center gap-1">
      <span className="font-medium">CBRE AskAWatch</span> 
      <span>is powered by Ellis AI</span>
      </div>
      <div className="italic pr-3">AI-generated content - please review before using</div>
    </div>
  );
} 